import { useEffect, useRef } from 'react';

import { MediaPreviewHandle } from '../../../types/media-preview';

/**
 * タイムラインのプレイヘッド更新用 rAF ループ。
 * 毎フレーム、再生ハンドルから現在時刻と duration を取得してコールバックする。
 * コールバック側は React state を極力介さず ref 直接操作で描画を更新する想定。
 */
export function useTimelinePlayhead(options: {
  enabled: boolean;
  getHandle: () => MediaPreviewHandle | null;
  onFrame: (_currentTime: number, _duration: number) => void;
}): void {
  const { enabled } = options;

  // 最新のコールバック / getter を ref に保持して rAF ループの再起動を防ぐ
  const getHandleRef = useRef(options.getHandle);
  getHandleRef.current = options.getHandle;
  const onFrameRef = useRef(options.onFrame);
  onFrameRef.current = options.onFrame;

  useEffect(() => {
    if (!enabled) return;

    let rafId = 0;
    const tick = () => {
      const handle = getHandleRef.current();
      if (handle) {
        const duration = handle.getDuration();
        onFrameRef.current(
          handle.getCurrentTime(),
          Number.isFinite(duration) ? duration : 0,
        );
      }
      rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [enabled]);
}
